<template>
    <v-app>
        <v-content id="mainContent">
            <v-alert :value="true" class="hide-on-print" type="success">Your application has been submitted successfully
                !
            </v-alert>
            <div class="mt-2" id="pdfContent" v-html="pdfDetails.print_content">

            </div>
            <div class="mb-3" style="display: flex; justify-content: flex-end;">
                <v-btn @click="print" class="hide-on-print mr-3" color="primary" depressed large>Print</v-btn>
                <v-btn
                    @click="saveAsPdf"
                    class="hide-on-print mr-3"
                    color="secondary"
                    depressed
                    large>Download
                </v-btn>
                <v-btn
                    @click="redirectHome"
                    class="hide-on-print hide-on-xs mr-3 white--text"
                    color="green"
                    depressed
                    large
                >Done
                </v-btn>
            </div>
        </v-content>
    </v-app>
</template>

<script>
    import {BASE_URL} from "../config/config";

    export default {
        name: "VisaApplicationPrint",
        data() {
            return {
                logo: BASE_URL + "logo.png"
            };
        },
        computed: {
            pdfDetails() {
                return this.$store.state.VisaSingle.pdfDetails;
            },
        },

        beforeRouteEnter(to, from, next) {
            if (!from.name || from.name === 'PrintApplication') {
                next(vm => {
                    let apply_type = vm.$route.params.apply;
                    let office = vm.$route.params.office;
                    if (apply_type === 'arrival') {
                        vm.$router.push({
                            name: 'OnArrival',
                            params: {office}
                        })
                    } else {
                        vm.$router.push({
                            name: 'OnlineApplication'
                        })
                    }
                })
            }
            next();
        },
        methods: {
            print() {
                window.print();
            },
            saveAsPdf() {
                window.open(this.pdfDetails.download_link, "_blank");
            },
            redirectHome() {
                let apply_type = this.$route.params.apply;
                let office = this.$route.params.office;
                if (apply_type === 'arrival') {
                    this.$router.push({
                        name: 'OnArrival',
                        params: {office}
                    })
                } else {
                    this.$router.push({
                        name: 'OnlineApplication'
                    })
                }
            }
        },
    };
</script>

<style>
    @media print {
        .hide-on-print {
            display: none;
        }
    }
</style>

